import { Box, Button, styled } from "@mui/material";
import purpleShadow from "../../../assets/img/common/purpleShadow.webp";
import { motion } from "framer-motion";

export const Main = styled(Box)(() => ({
  width: "100%",
  height: "calc(100% - 5rem)",
  overflow: "hidden",
  touchAction: "none",
  position: "relative",
  WebkitOverflowScrolling: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "Space Grotesk",
  userSelect: "none",
  "@media (max-width: 768px)": {
    height: "calc(100% - 2.5rem)",
  },
}));

export const PageContent = styled(Box)(({ height }: { height: number }) => ({
  position: "relative",
  width: `${height / 2}px`,
  height: "calc(100% - 1rem)",
  margin: "0.5rem 0",
  "@media (max-width: 768px)": {
    width: "100%",
    height: "100%",
    margin: "0",
  },
}));

export const Content = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  marginTop: "1rem",
  position: "relative",
  "@media (max-width: 768px)": {
    marginTop: "0rem",
  },
}));

export const HeaderContent = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  padding: "1rem 0.5rem",
  margin: "0.5rem 0 1rem 0",
}));

export const PartContent = styled(Box)(() => ({
  position: "absolute",
  left: 0,
  right: 0,
  margin: "0 auto",
  width: "16rem",
}));

export const StyledButton = styled(Button)(() => ({
  marginTop: "0 !important",
  minWidth: "1rem",
  padding: "0 1rem",
  margin: "0",
  textTransform: "unset",
  color: "#8E98B4",
  fontSize: "1rem",
  "&:hover": {
    backgroundColor: "unset !important",
  },
}));

export const Title = styled(Box)(() => ({
  margin: "0.5rem 0 1rem 0",
  textAlign: "center",
  fontWeight: "600",
  fontSize: "1.25rem",
  color: "#fff",
  "@media (max-width: 768px)": {
    marginBottom: "2rem",
  },
}));

export const ColoredText = styled("span")(() => ({
  color: "#E5FA40",
}));

export const OptionsContent = styled(motion.div)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "2rem",
  margin: "1rem 0",
  cursor: "pointer",
  background: `url(${purpleShadow})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  position: "relative",
  perspective: "1000px",
}));

export const StyledImage = styled(motion.img)(({ height }: { height: number }) => ({
  userSelect: "none",
  height: `${height / 3.5}px`,
  width: `${height / 3.5}px`,
  objectFit: "contain",
  transform: "rotateX(0)",
  transformOrigin: "center",
}));

export const SelectedOption = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "1.5rem",
  gap: "1rem",

  "@media (max-width: 768px)": {
    marginBottom: "1.5rem",
  },

  "@media (max-height: 700px) and (max-width: 768px)": {
    marginBottom: "0.5rem",
  },
}));

export const SelectedOptionTitle = styled(Box)(() => ({
  color: "#E5FA40",
  fontSize: "1.25rem",
  fontWeight: "700",
}));

export const SelectedOptionSubTitle = styled(Box)(() => ({
  color: "#fff",
  fontSize: "0.875rem",
  textAlign: "center",
  padding: "0 2rem",
  minHeight: "2.25rem",
}));

export const CustomButtonContainer = styled(Box)(() => ({
  position: "absolute",
  bottom: "1rem",
  left: "1rem",
  right: "1rem",
  width: "calc(100% - 2rem)",
  height: "3rem",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "@media (max-width: 768px)": {
    left: "1rem",
    right: "1rem",
    width: "calc(100% - 2rem)",
  },
}));

export const CustomButton = styled(Button)(() => ({
  width: "25rem",
  // margin: "2rem 0",
  borderRadius: "2rem",
  height: "3rem",
  background: "#E5FA40",
  color: "#232D49",
  textTransform: "none",
  fontWeight: 500,
  fontFamily: "Space Grotesk",
  "&:disabled": {
    background: "#899628 !important",
    color: "#232D49 !important",
  },
  "&:hover": {
    background: "#E5FA40 !important",
  },
}));
